import { IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  environmentName: 'local',
  production: false,
  mediaApiUrl: 'api/media/',
  apiUrl: 'api/backend/',
  notificationsApiUrl: 'api/notifications/',
  aspUrl: 'api/asp/',
  appVersion: 'v8.0.27',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
};
